

export default {
  name: 'BoxPdFlagThumb',
  props: {
    count: {
      type: [Number, String],
      default: 0
    },
    useSize: {
      type: String, // sm, md, lg, xl
      default: 'lg'
    }
  },
}
